import Table from 'react-bootstrap/Table';
import { FaTimes } from 'react-icons/fa';

const InventoryUploadResult = ({ uploadResponse }) => {
    const errored = uploadResponse.errored;
    const updated = uploadResponse.updated;

    return (
        <>
            {errored && errored.length
            ? <h5>Archivo subido con errores</h5>
            : <h5>Archivo subido con éxito</h5>
            }
            <br />
            <Table bordered hover>
                <thead>
                    <tr>
                        <th>
                            Bodega
                        </th>
                        <th>
                            Ubicación
                        </th>
                        <th>
                            Cantidad previa
                        </th>
                        <th>
                            Ítems agregados
                        </th>
                        <th>
                            Cantidad nueva
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {updated.map((item, index) => (
                        <tr key={"updated_" + index}>
                            <td>
                                {item.store}
                            </td>
                            <td>
                                {item.name}
                            </td>
                            <td>
                                {item.prevQty}
                            </td>
                            <td>
                                <strong>
                                    {item.addedQty}
                                </strong>
                            </td>
                            <td>
                                <strong>
                                    {item.prevQty + item.addedQty}
                                </strong>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>

            {errored && errored.length
            ? <div className="mt-4">
                <div className="text-start">
                    <h5>
                        Errores al subir inventario:
                    </h5>
                </div>
                
                <Table bordered hover>
                    <thead>
                        <tr>
                            <th>
                                Bodega
                            </th>
                            <th>
                                Ubicación
                            </th>
                            <th>
                                Ítems a agregar
                            </th>
                            <th>
                                Error
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {errored.map((item, index) => (
                            <tr key={"updated_" + index}>
                                <td>
                                    {item.store}
                                </td>
                                <td>
                                    {item.name}
                                </td>
                                <td>
                                    <strong>
                                        {item.addedQty}
                                    </strong>
                                </td>
                                <td className="text-start">
                                    <FaTimes className="text-danger" /> <span>{item.msg}</span>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>   
            </div>
            : null
            }
        </>
    );
}

export default InventoryUploadResult;
